const DropDownIcon = () => (
  <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M15.9992 8.38281L8.16657 0L0.333984 8.38281H2.9205L8.16657 2.76821L13.4127 8.38281H15.9992Z" fill="black" />
  </svg>
);

export default DropDownIcon;
